import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Box } from '../containers';
import { printDateObjectAsFormattedString } from '../../helpers';
import { selectFormattedMinimumDate, selectFormattedMaximumDate, selectGrid } from './CalendarSelectors';
import arrowLeftIcon from '../../img/arrow-left-blue.svg';
import arrowRightIcon from '../../img/arrow-right-blue.svg';
import s from './Calendar.css';

const propTypes = {
    className: PropTypes.string,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    value: PropTypes.object,
    showDays: PropTypes.bool.isRequired,
    displayedDate: PropTypes.object.isRequired,
    weekDayNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    onDateChange: PropTypes.func.isRequired,
    onDisplayedMonthChange: PropTypes.func.isRequired,
    onPeriodArrowClick: PropTypes.func.isRequired,
    onDaysMonthsToggle: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
    formattedMinimumDate: selectFormattedMinimumDate(state, ownProps),
    formattedMaximumDate: selectFormattedMaximumDate(state, ownProps),
    grid: selectGrid(state, ownProps),
});

class CalendarContent extends React.Component {
    render() {
        return (
            <Box className={classNames(s.calendar, this.props.className)}>
                <div className={classNames(s.row, s.navigation)}>
                    <div className={s.arrowContainer}>
                        <button onClick={this.handlePeriodArrowClick('left')}>
                            <img src={arrowLeftIcon} alt="" />
                        </button>
                    </div>

                    <div className={s.monthContainer}>
                        <button className={s.daysMonthsToggle} onClick={this.props.onDaysMonthsToggle}>
                            {this.props.displayedDate
                                ? this.props.showDays
                                    ? printDateObjectAsFormattedString(this.props.displayedDate, 'MMMM YYYY')
                                    : printDateObjectAsFormattedString(this.props.displayedDate, 'YYYY')
                                : ''}
                        </button>
                    </div>

                    <div className={s.arrowContainer}>
                        <button onClick={this.handlePeriodArrowClick('right')}>
                            <img src={arrowRightIcon} alt="" />
                        </button>
                    </div>
                </div>

                <div className={classNames(s.row, s.weekDays)}>
                    {(this.props.showDays &&
                        this.props.weekDayNames.map((dayName, dayId) => (
                            <div key={dayId}>
                                <p>{dayName}</p>
                            </div>
                        ))) || (
                        <div key="monthsLine">
                            <p>Jump to any month</p>
                        </div>
                    )}
                </div>

                <div className={this.props.grid.className}>
                    {this.props.grid.rows.map(row => (
                        <div className={s.row} key={row.key}>
                            {row.days.map(day => (
                                <div key={day.id}>
                                    <button
                                        onClick={day.isDisabled ? undefined : this.props.onDateChange(day.id)}
                                        title={
                                            day.isDisabled
                                                ? day.isDisabledBecause === 'older-than-max-date'
                                                    ? 'Days after ' + this.props.formattedMaximumDate + ' are disabled'
                                                    : day.isDisabledBecause === 'younger-than-min-date'
                                                        ? 'Days before ' +
                                                          this.props.formattedMinimumDate +
                                                          ' are disabled'
                                                        : undefined
                                                : undefined
                                        }
                                        className={classNames({
                                            [s.daySelected]: day.isSelected,
                                            [s.dayNotCurrentMonth]: day.isCurrentMonth === false,
                                            [s.dayToday]: day.isToday,
                                            [s.dayDisabled]: day.isDisabled,
                                        })}
                                    >
                                        <span>{day.dateString}</span>
                                    </button>
                                </div>
                            ))}

                            {row.months.map(month => (
                                <div key={month.id}>
                                    <button
                                        onClick={this.props.onDisplayedMonthChange(month.id)}
                                        className={classNames({
                                            [s.monthSelected]: month.isSelected,
                                        })}
                                    >
                                        {month.monthString}
                                    </button>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </Box>
        );
    }

    handlePeriodArrowClick = direction => e => {
        if (this.props.onPeriodArrowClick) {
            this.props.onPeriodArrowClick(direction);
        }
    };
}

CalendarContent.propTypes = propTypes;

export default connect(mapStateToProps)(CalendarContent);



// WEBPACK FOOTER //
// ./app/web/src/components/fields/CalendarContent.jsx